

































import Vue, { PropType } from 'vue';
import { Cv, CvSectionSkill, CvSectionSkillItem } from '@/../gen';
// @ts-ignore
import SectionPreviewField from '@/components/section-preview/SectionPreviewField.vue';

export default Vue.extend({
  components: {
    SectionPreviewField,
  },
  props: {
    cv: {
      type: Object as PropType<Cv>,
      required: true,
    },
    section: {
      type: Object as PropType<CvSectionSkill>,
      required: true,
    },
    sectionItems: {
      type: Array as PropType<CvSectionSkillItem[]>,
      required: true,
    },
  },
});
